<div class="page-container">
  <div [@fadeInUp] class="login-card">
    <div class="logo-container">
      <img src="assets/img/logo-dark.png" />
    </div>

    <div [formGroup]="form" class="form-container">
      <div>
        <h1>Nouveau Mot de passe</h1>
        <p>Veuillez renseigner et confirmer votre nouveau mot de passe</p>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Nouveau mot de passe</mat-label>
          <mat-error *ngIf="form.controls.password.hasError('minlength')">Le mot de passe doit contenir au minimun 8 charactères </mat-error>
          <input type="password" matInput placeholder="Mot de passe" formControlName="password" minlength="8" required />
          <mat-hint>Veuillez renseigner votre nouveau mot de passe</mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Confirmez votre nouveau mot de passe</mat-label>
          <mat-hint>Veuillez confirmer votre nouveau mot de passe</mat-hint>
          <input type="password" matInput placeholder="Confirmation du mot de passe" formControlName="confirmPassword" minlength="8" required />
          <mat-error *ngIf="form.controls.confirmPassword.hasError('mismatchedPasswords')">Le mot de passe est incorrect</mat-error>
        </mat-form-field>

        <mat-error *ngIf="form.controls.confirmPassword.hasError('mismatchedPasswords')">Le mots de passe est incorrect</mat-error>
      </div>

      <div class="form-action">
        <button type="button" mat-raised-button (click)="resetPassword()">Envoyer</button>
      </div>
      <div class="form-action">
        <button class="return-btn" type="button" mat-raised-button [routerLink]="'/login'">Ecran de connexion</button>
      </div>
    </div>
  </div>
</div>
